import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b66c3de"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel-block",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "table is-fullwidth" }
const _hoisted_3 = { title: "Clique" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(", ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.t("amountClique")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.cliquesList.length), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cliquesList, (clique, cliqueIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: 'clique-number-' + cliqueIndex
          }, [
            _createElementVNode("th", {
              onClick: ($event: any) => (_ctx.clickClique(clique.alters)),
              class: "clickAble"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clique.alters, (a, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `a_${cliqueIndex}_${idx}`
                }, [
                  (idx > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_5
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass({ selalter: _ctx.isSelected(a.id) })
                  }, _toDisplayString(a.name), 3)
                ], 64))
              }), 128))
            ], 8, _hoisted_4),
            _createElementVNode("td", null, _toDisplayString(clique.description), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}